export const getAreaData = (store) => store.areaform.editData;
